import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteDocumentTemplate } from '@dealstack/frontend/shared/dataExchange/services/documentTemplates.service';
import { useTranslationDefault } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2.tsx';
import { documentTemplateMutationError } from '@dealstack/frontend/app/pages/DocumentTemplates/api/documentTemplateMutationError';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';

export const useDeleteDocumentTemplate = () => {
	const tDefault = useTranslationDefault();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (id: string) => deleteDocumentTemplate(id),
		onSuccess: async () => {
			await queryClient.invalidateQueries({ queryKey: [API_PATHS.DOCUMENT_TEMPLATES_GET] });
			showToastV2({
				title: tDefault('document_templates.toast.deleted'),
			});
		},
		onError: (error: unknown) => documentTemplateMutationError(error, tDefault),
	});
};
